import { defineMessages } from "react-intl";

import {
	acuteLiverFailureCauseMessages,
	hepatologyTypeMessages,
	malignantDiseaseOfTheLiverCauseMessages,
	metabolicLiverDiseaseCauseMessages,
	miscellaneousCauseMessages,
	validator,
	vascularDiseasesOfTheLiverCauseMessages
} from "lib/build/forms/ktx/transplantation-screening/medical-history/hepatologyDiseases";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hepatologyDiseases: {
		id: "ktx.form.hepatologyDiseases",
		defaultMessage: "Hepatológiai betegség"
	},
	hepatologyDiseasesType: {
		id: "ktx.form.hepatologyDiseases.type",
		defaultMessage: "Betegség"
	},
	hepatologyDiseasesCause: {
		id: "ktx.form.hepatologyDiseases.cause",
		defaultMessage: "Oka"
	},
	comment: {
		id: "ktx.form.hepatologyDiseases.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	hepatologyType: {
		type: "field",
		path: ["hepatologyType"],
		label: messages.hepatologyDiseasesType,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: hepatologyTypeMessages }
		}
	},
	acuteLiverFailureCause: {
		type: "field",
		path: ["acuteLiverFailureCause"],
		label: messages.hepatologyDiseasesCause,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: acuteLiverFailureCauseMessages }
		}
	},
	malignantDiseaseOfTheLiverCause: {
		type: "field",
		path: ["malignantDiseaseOfTheLiverCause"],
		label: messages.hepatologyDiseasesCause,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: malignantDiseaseOfTheLiverCauseMessages }
		}
	},
	metabolicLiverDiseaseCause: {
		type: "field",
		path: ["metabolicLiverDiseaseCause"],
		label: messages.hepatologyDiseasesCause,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: metabolicLiverDiseaseCauseMessages }
		}
	},
	vascularDiseasesOfTheLiverCause: {
		type: "field",
		path: ["vascularDiseasesOfTheLiverCause"],
		label: messages.hepatologyDiseasesCause,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: vascularDiseasesOfTheLiverCauseMessages }
		}
	},
	miscellaneousCause: {
		type: "field",
		path: ["miscellaneousCause"],
		label: messages.hepatologyDiseasesCause,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: miscellaneousCauseMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: {
			type: "textarea",
			props: {}
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.hepatologyType }] },
		{ columns: [{ width: 12, field: fields.acuteLiverFailureCause }] },
		{
			columns: [
				{ width: 12, field: fields.malignantDiseaseOfTheLiverCause }
			]
		},
		{ columns: [{ width: 12, field: fields.metabolicLiverDiseaseCause }] },
		{
			columns: [
				{ width: 12, field: fields.vascularDiseasesOfTheLiverCause }
			]
		},
		{ columns: [{ width: 12, field: fields.miscellaneousCause }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_hepatologyDiseases",
	value: {
		schemaId: "hepatologyDiseases",
		title: messages.hepatologyDiseases,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
